export var EPortraitStatus;
(function (EPortraitStatus) {
    EPortraitStatus["NORMAL"] = "NORMAL";
    EPortraitStatus["UNEFFECTIVE"] = "UNEFFECTIVE";
    EPortraitStatus["INVALIDATING"] = "INVALIDATING";
})(EPortraitStatus || (EPortraitStatus = {}));
export var EPassCodeStatus;
(function (EPassCodeStatus) {
    EPassCodeStatus["GENERATED"] = "GENERATED";
    EPassCodeStatus["UNGENERATE"] = "UNGENERATE";
})(EPassCodeStatus || (EPassCodeStatus = {}));
